import { RequestCRUD } from "src/app/shared/services/abstract/request-crud.service";
import { ResponseServiceModel } from "src/app/shared/models/response-service.model";
import { Injectable } from "@angular/core";
import { Observable } from "rxjs";
import { HttpClient } from "@angular/common/http";
import { HttpErrorHandler } from "src/app/shared/services/handle-error.service";
import { retry } from "rxjs/operators";
import { environment } from "src/environments/environment";
import { RNTPrestadorEntry } from "src/app/shared/entrys/rnt-prestador.entry";
import { EnviromentGlobalService } from "src/app/shared/services/enviroment-global.service";

@Injectable()
export class SolicitudService
  implements RequestCRUD<RNTPrestadorEntry, ResponseServiceModel> {
  private API_URL;
  constructor(
    private http: HttpClient,
    httpErrorHandler: HttpErrorHandler,
    private enviromentGlobalService: EnviromentGlobalService
  ) {
    this.API_URL = enviromentGlobalService.apiUrl;
  }

  get(entry: any): Observable<ResponseServiceModel> {
    return this.http
      .post<ResponseServiceModel>(`${this.API_URL}/Solicitud/Recuperar`, entry)
      .pipe(retry(2));
  }
  getCamara(entry: any): Observable<ResponseServiceModel> {
    return this.http
      .post<ResponseServiceModel>(
        `${this.API_URL}/ContenidoCertificado/ContenidoCertificado`,
        entry
      )
      .pipe(retry(2));
  }
  getCamaraFile(entry: any): Observable<Blob> {
    return this.http
      .post<Blob>(`${this.API_URL}/ContenidoCertificado/ObtenerRecurso`, entry)
      .pipe(retry(2));
  }
  getCamaraPorMunicipio(entry: any): Observable<ResponseServiceModel> {
    return this.http
      .get<ResponseServiceModel>(
        `${this.API_URL}/Rnt/LogoCamaraPorMunicipio/${entry}`
      )
      .pipe(retry(2));
  }
  update(entry: RNTPrestadorEntry): Observable<ResponseServiceModel> {
    throw new Error("Method not implemented.");
  }
  create(entry: RNTPrestadorEntry): Observable<ResponseServiceModel> {
    throw new Error("Method not implemented.");
  }
  delete(entry: RNTPrestadorEntry): Observable<ResponseServiceModel> {
    throw new Error("Method not implemented.");
  }

  sincronizarEnSolicitud(entry: any): Observable<ResponseServiceModel> {
    return this.http
      .post<ResponseServiceModel>(
        `${this.API_URL}/Generico/Sincronizacion`,
        entry
      )
      .pipe(retry(2));
  }
  notificarErroresValidacionSolicitud(solicitud_id: string) {
    return this.http
      .post<ResponseServiceModel>(
        `${this.API_URL}/Solicitud/NotificarErroresValidacionSolicitud/`,
        {
          solicitud_id
        }
      )
      .pipe(retry(2));
  }
  aplicaEstudioAutomatico(solicitud_id: string) {
    return this.http
      .get<ResponseServiceModel>(
        `${this.API_URL}/Solicitud/${solicitud_id}/AplicaEstudioAutomatico`
      )
      .pipe(retry(2));
  }
}
